import { Constants } from "./constants";


export class BookTemplates {
   
    public themeIds = [];
    public type: String = 'bookTemplates';
    public _id: String = '';
    public owner: String = Constants.USER;

    
}



// WEBPACK FOOTER //
// ./src/app/shared/models/bookTemplates.ts